"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    soilIonicContent: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    soilMoisture: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    soilTemperature: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    soilVwc: _aggregation_helpers_1.defaultAggregationIntervalHelper,
};
//# sourceMappingURL=soil.js.map